/* eslint-disable camelcase */
import {
	UpsellServiceAssociatedObjectContentTypeEnum,
	UpsellServiceEnum,
} from '.spec/self-care/tsTypes';

import { toFloat } from '@skippay/core/utils/amountUtils';
import { insertParams } from '@skippay/core/utils/routeUtils';

import type { UpsellServiceAvailableOffer } from '@types/upsellServiceAvailableOffer';
import {
	UPSELL_SERVICE_BNPL_CREATE_NEW,
	UPSELL_SERVICE_CALCULATOR,
	UPSELL_SERVICE_TRANSACTION_CREATE_NEW,
} from 'constants/routes';
import { createAbsoluteHref } from 'utils/routeUtils';

import { JARABOT_EVENTS } from '../jarabotClient';
import { InsuranceContactSelection, InsuranceContactType } from './types';

type InsuranceOfferPayloadService = {
	service: UpsellServiceEnum;
	deadline: string | null;
};

type InsuranceOfferPayloadPurchase = {
	item_name: string | null;
	purchase_date: string;
	purchase_price: number;
	available_services: InsuranceOfferPayloadService[];
	arrange_url: string;
};

export type InsuranceOfferPayload = {
	step: typeof JARABOT_EVENTS.CUSTOMER_INSURANCE_OFFER;
	contact_type: InsuranceContactType;
	calculator_url: string;
	purchases: InsuranceOfferPayloadPurchase[];
};

const buildArrangeUrl = (offer: UpsellServiceAvailableOffer, selfCareUrl: string): string => {
	const isApplication =
		offer.associatedObjectCt === UpsellServiceAssociatedObjectContentTypeEnum.APPLICATION;
	const path: string = insertParams(
		isApplication ? UPSELL_SERVICE_BNPL_CREATE_NEW : UPSELL_SERVICE_TRANSACTION_CREATE_NEW,
		isApplication
			? { applicationId: offer.associatedObjectId }
			: { transactionId: offer.associatedObjectId }
	);

	return createAbsoluteHref(path, selfCareUrl);
};

interface BuildInsuranceOfferPayloadParams {
	selection: InsuranceContactSelection;
	selfCareUrl: string;
}

export function createInsuranceOfferPayload({
	selection,
	selfCareUrl,
}: BuildInsuranceOfferPayloadParams): InsuranceOfferPayload {
	return {
		step: JARABOT_EVENTS.CUSTOMER_INSURANCE_OFFER,
		contact_type: selection.contactType,
		calculator_url: createAbsoluteHref(UPSELL_SERVICE_CALCULATOR, selfCareUrl),
		purchases: selection.purchases.map((offer) => ({
			item_name: offer.highestPricedItemName,
			purchase_date: offer.purchaseDate,
			purchase_price: toFloat(offer.purchasePrice),
			available_services: offer.availableServices.map(({ service, availabilityDeadline }) => ({
				service,
				deadline: availabilityDeadline,
			})),
			arrange_url: buildArrangeUrl(offer, selfCareUrl),
		})),
	};
}
